import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import Stack from 'react-bootstrap/Stack';
import { render } from 'storyblok-rich-text-react-renderer';
import { useSelector } from 'react-redux';
import UnderlyingCard from './UnderlyingCard';
import API from '../../services/API';

const filterUnderlyings = (assetClasses, underlyings) => {
  const flattenUnderlyingList = assetClasses.reduce((arr, elem) => {
    elem.groups.forEach((group) => {
      arr.push(...group.underlyingList);
    });
    return arr;
  }, []);
  return flattenUnderlyingList.filter((item) =>
    underlyings.includes(item.ticker));
};

const getTextURL = (fileUrl) => {
  try {
    const url = new URL(fileUrl);
    return url.href;
  } catch {
    const { origin } = window.location;
    const { isoCode = 'en-GB' } = window.ttCentre;
    return `${origin}/${isoCode.toLowerCase()}/${fileUrl}`;
  }
};

const PostModal = (props) => {
  const assetClasses = useSelector((state) => state.app).data;
  const { post, onHide, onEscapeKeyDown } = props;
  const {
    postTitle,
    postDescriptionText,
    externalFileLinks = [],
    image,
    underlyings = [],
  } = post;
  const { filename } = image;
  const [openLayer, setOpenModal] = useState(false);
  const unerlyings = filterUnderlyings(assetClasses, underlyings);
  return (
    <Modal
      onHide={onHide}
      show
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ opacity: !openLayer ? 1 : 0 }}
      dialogClassName="modal-90w"
      onEscapeKeyDown={onEscapeKeyDown}
    >
      <Modal.Header closeButton className="border-0 p-5 pb-0" />
      <Modal.Body className="px-sm-3 mx-sm-3 px-md-4 mx-md-4 px-lg-5 mx-lg-5 pb-5 mb-5">
        <Row className="mb-4">
          <Col>
            <h4>{postTitle}</h4>
          </Col>
        </Row>
        <div className="">
          <Row className="p-0" direction="horizontal" gap={5}>

            <Col sm={12}>
              {filename && (
              <Image
                src={filename}
                className="img-container p-0 d-none d-md-block float-end modal-img"
              />
              )}

              {render(postDescriptionText)}

              {externalFileLinks.length > 0
              && externalFileLinks.map((pdf) => (
                <div key={pdf.fileName}>
                  <Card.Link
                    className={`mt-auto pdf-link-ttcentre ${pdf.pdfFileUrl.url.indexOf('.pdf') !== -1 ? 'pdf-link-ttc' : 'post-file-link'}`}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      API.sendToGA(
                        getTextURL(pdf.pdfFileUrl.url),
                        'pdf downloads',
                      );
                      window.open(getTextURL(pdf.pdfFileUrl.url), '_blank');
                    }}
                    target="_blank"
                  >
                    {pdf.fileName}
                  </Card.Link>
                </div>
              ))}
              {unerlyings.map((underlying) => (
                <div className="mt-4">
                  <UnderlyingCard
                    underlying={underlying}
                    key={underlying.ticker}
                    setOpenModal={setOpenModal}
                    postTitle={postTitle}
                  />
                </div>
              ))}

            </Col>

            {filename && (
              <Col md={12} lg={6} className="d-flex flex-wrap align-items-center" />
            )}
            <Col md={12} lg={filename ? 6 : 12} />
          </Row>
          <Stack className="p-0 mt-5 float-none" />
        </div>
      </Modal.Body>
    </Modal>
  );
};

PostModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  onEscapeKeyDown: PropTypes.func.isRequired,
  post: PropTypes.shape({
    postCreatedDate: PropTypes.string.isRequired,
    postTitle: PropTypes.string.isRequired,
    postDescriptionText: PropTypes.shape({}).isRequired,
    externalFileLinks: PropTypes.arrayOf(PropTypes.shape([]).isRequired),
    underlyings: PropTypes.arrayOf(PropTypes.string).isRequired,
    image: PropTypes.shape({
      filename: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default PostModal;
